import ValueInterface, { SerializedValueType } from "./ValueInterface"

// https://www.alt-codes.net/plus-sign-symbols
export default class SumValue implements ValueInterface {
  constructor(
    private readonly left: ValueInterface,
    private readonly right: ValueInterface,
  ) {}

  public toString(): string {
    return `${this.left.toString()} + ${this.right.toString()}`
  }

  public normalize(): number {
    return this.left.normalize() + this.right.normalize()
  }
  public clone(): SumValue {
    return new SumValue(this.left.clone(), this.right.clone())
  }

  public toJSON(): SerializedValueType {
    return {
      type: "sum",
      payload: {
        left: this.left.toJSON(),
        right: this.right.toJSON(),
      },
    }
  }
}
